import BackTraceList from "@/sections/WebSummary/BackTrace/BackTraceList";
const Todo = () => {

  return (
    <div className="mt-2.5 text-3.5 select-text">
      <BackTraceList
        module="todo"
        emptyText=""
        itemClassName="px-2 b-dashed b-b-1.5px b-transparent lh-7 text-3.5 color-#30343C rounded-1 border-0 outline-0 block resize-none bg-transparent"
      />
    </div>
  );
};

export default Todo;

